import React from "react";

export default ({ children }) => (
  <p style={{ fontSize: "0.7em" }}>{children}</p>
);



// WEBPACK FOOTER //
// ./src/components/Text.js